export const getFilePath = (path: string, fileName: string): string => {
  const folderArray = [
    {
      name: 'news',
      path: '/images/news/'
    },
    {
      name: 'news',
      path: '/images/news/'
    },
    {
      name: 'news-doc',
      path: '/files/news/'
    },
    {
      name: 'rules-doc',
      path: '/files/rules/'
    },
    {
      name: 'gallery',
      path: '/images/gallery/'
    },
    {
      name: 'about-us',
      path: '/images/about-us/'
    },
    {
      name: 'slider',
      path: '/images/home-slider/'
    },
    {
      name: 'owner-spklu',
      path: '/images/owner-spklu/'
    },
    {
      name: 'user-profile',
      path: '/images/users-avatar/'
    },

  ];
  const folder = folderArray.find(folder => folder.name == path);
  return process.env.VUE_APP_FILE_URL + folder?.path + fileName;
}
